interface Props {
  className?: string
  faction?: string | null
  fileName?: string
  size: 'custom' | 'small' | 'large'
}

const BannerImage = ({ className, faction, fileName, size }: Props) => {
  return (
    <figure
      className={`${className} ${
        size === 'custom'
          ? ''
          : size === 'small'
          ? 'w-10 h-10 min-w-[2.5rem] min-h-[2.5rem]'
          : 'w-[7rem] h-[7rem] min-w-[7rem] min-h-[7rem]'
      } bg-cover`}
      style={{
        backgroundImage: `url(https://data.wowaudit.com/crests/${
          fileName ?? `default-${(faction ?? 'Alliance').toLowerCase()}.png`
        })`,
      }}
    />
  )
}

export default BannerImage
